<template>
  <div>
    <failed-payment-notification-bar/>
    <div class="account-settings">
      <subscription-settings/>
      <churn-button/>
    </div>
  </div>
</template>

<script>
import SubscriptionSettings from './SubscriptionSettings.vue';
import ChurnButton from './components/ChurnButton.vue';
import Segment from '../../../../../Segment';
import FailedPaymentNotificationBar from './components/FailedPaymentNotificationBar.vue';

export default {
  name: 'account-settings',
  components: {
    FailedPaymentNotificationBar,
    SubscriptionSettings,
    ChurnButton,
  },
  created() {
    Segment.trackUserGot('AccountSettingsEntered');
  },
};
</script>

<style scoped lang="scss">
@import '../../../../../scss/mixins';
  .account-settings {
    @include responsive-padding;
    padding-top: 17px;
  }

</style>
